'use client';
const StepperCompleted = () => null;
StepperCompleted.displayName = "@mantine/core/StepperCompleted";

export { StepperCompleted };
//# sourceMappingURL=StepperCompleted.mjs.map
